import React, { Component } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import moment, { relativeTimeRounding } from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import filterIcon from '../css/dark/img/filter.svg';
import 'bootstrap-daterangepicker/daterangepicker.css';
import $ from 'jquery';
import List from '../List';
import Bar_List from '../BarList';
import MultiBar_List from '../MultiAxisBar_List';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import Search_Icon from '../../components/css/dark/img/theme-images/search.svg';
import ColorJson from '../../../src/whitelabel.json';

class Analytics extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }

        try {
            this.state = {
                WidgetList: [],
                startDate: new moment(startdate).format("MM/DD/YYYY"),
                endDate: new moment(enddate).format("MM/DD/YYYY"),
                AnalyticData: [],
                userdata: JSON.parse(localStorage.getItem('user')),
                scrollArray: {},
                graphData: [],
                AnalyticList: [],
                FilterTagList: [],
                FilterMatchedTagList: [],
                SearchDispay: [],
                isEnrollEndpointEnabled: false,
                API_Signup: false,
                Enrollment_Center_Signup: false,
                Client_Acces_Link_Signup: false,
            };
        }
        catch (error) { }
        this.handleCalendar = this.handleCalendar.bind(this);
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
            });
            $(".dashboard-container").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".dashboard-container").animate({
                marginLeft: -170 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    componentDidMount() {
        try {
            if (userService.Check_LoggedIn_Status() != 'Login') {
                $('.readonly-attr').attr('readonly', 'readonly');
                this.setState({ AnalyticList: JSON.parse(localStorage.getItem('analytics_data')) });
                this.GetWholesalers_Enrollment_API_Status(this.state.userdata.wholesaler_Id);
                //this.changeData();
                $('body').addClass('analyticPage');
                $('.sidebar-submenu').show();
                $(".analytics-menu").click(e => {
                    if ($('.collapseButton').hasClass("active")) {
                        this.handleCollapse();
                        $('.sidebar-submenu').show();
                        $('body').toggleClass('sub-menu-active');
                    }
                });
                var AnalyticFilterJson = '';
                try {
                    AnalyticFilterJson = JSON.parse(localStorage.getItem('Analytic_Filter'))
                    if (AnalyticFilterJson != null && AnalyticFilterJson != '' && AnalyticFilterJson != undefined && AnalyticFilterJson != "null") {
                        this.setState({ FilterTagList: JSON.stringify(AnalyticFilterJson) });
                    }
                    else {
                        this.setState({ FilterTagList: '' });
                    }
                }
                catch (error) {
                    this.setState({ FilterTagList: '' });
                }
                let ds = new moment(this.state.startDate).format("YYYYMMDD");
                let de = new moment(this.state.endDate).format("YYYYMMDD");
                let nJson = JSON.stringify(AnalyticFilterJson);
                if (AnalyticFilterJson != null) {
                    this.BindFilteredTag(this.state.userdata["userrole"], -1, this.state.userdata["wholesaler"], this.state.userdata["wholesaler_Id"], ds, de, nJson);
                }
            }
        } catch (error) { }
    }
    componentWillUnmount() {
        $('body').removeClass('analyticPage');
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        this.changeData(true, changedStartDate, changedEndDate);
        var AnalyticFilterJson = '';
        try {
            AnalyticFilterJson = JSON.parse(localStorage.getItem('Analytic_Filter'))
            if (AnalyticFilterJson != null && AnalyticFilterJson != '' && AnalyticFilterJson != undefined && AnalyticFilterJson != "null") {
                this.setState({ FilterTagList: JSON.stringify(AnalyticFilterJson) });
            }
            else {
                this.setState({ FilterTagList: '' });
            }
        }
        catch (error) {
            this.setState({ FilterTagList: '' });
        }
        let ds = new moment(changedStartDate).format("YYYYMMDD");
        let de = new moment(changedEndDate).format("YYYYMMDD");
        let nJson = JSON.stringify(AnalyticFilterJson);
        if (AnalyticFilterJson != null) {
            this.BindFilteredTag(this.state.userdata["userrole"], -1, this.state.userdata["wholesaler"], this.state.userdata["wholesaler_Id"], ds, de, nJson);
        }
        try {
            $('.first-one .form-control').val(changedStartDate);
            $('.second-one .form-control').val(changedEndDate);
        }
        catch (error) {
        }
    }
    handlechangea(e) {
        this.props.handeChangefilter(e);
    }
    fetchData(wh_id, wh_name) {
        try {
            userService.GetWh_Analytic(wh_id, wh_name).then(
                apidata => {
                    if (apidata.length > 0) {
                        this.setState({ WidgetList: apidata });
                    }
                }

            );
        }
        catch (error) { }
    }
    changeData(dateChanged, stdate, endate) {
        var wname = '';
        var startDateObj = '';
        var endDateObj = '';
        if (dateChanged == undefined) {
            startDateObj = this.state.startDate;
            endDateObj = this.state.endDate;
        }
        else {
            startDateObj = stdate;
            endDateObj = endate;
        }

        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        let changedStartDate = new moment(startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(endDate).format("MM/DD/YYYY");
        this.setState({ startDate: changedStartDate, endDate: changedEndDate });
        var AdFilterJson = '';
        AdFilterJson = JSON.parse(localStorage.getItem('Analytic_Filter'));
        var APIBaseURL = "";
        APIBaseURL = '/api/BrokerAnalytic';
        try {
            userService.GetWh_Analytic(this.state.userdata["wholesaler_Id"].toString(), "").then(
                apidata => {
                    if (apidata.length > 0) {
                        this.setState({ WidgetList: JSON.parse(JSON.stringify(apidata)) });
                        // for (var ij = 0; ij < apidata.length; ij++) {
                        //     APIBaseURL = '/api/Analytic';
                        //    if (ij == 0) APIBaseURL=APIBaseURL + "/date_wise_signup"; else APIBaseURL = APIBaseURL + "/gn_wise_signup";
                        //    var Widget1 = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
                        //    let rowdata = {
                        //        url: APIBaseURL,
                        //        type: this.state.WidgetList[ij].widgetType,
                        //        title: this.state.WidgetList[ij].widgetTitle,
                        //        Subtitle: this.state.WidgetList[ij].widgetSubTitle,
                        //        ColorCode: "#2A524B",
                        //        DataType: "NA",
                        //        XlabelString: "Date",
                        //        YlabelString: "Number of Signups",
                        //        interval: 'day',
                        //        id: "WTotalTransaction",
                        //        RequestJson: Widget1,
                        //        RequestJson1: JSON.stringify("")
                        //    };
                        //    this.setState({ dashboardName: wname, graphData: this.state.graphData.concat(rowdata) })
                        //}
                        try {
                            if (this.state.WidgetList.length > 1) {
                                var Widget1 = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + this.state.WidgetList[0].widgetAPI + "\"}";
                                var Widget2 = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + this.state.WidgetList[0].widgetAPI + "\"}";
                                var MultiAxis_DeviceSignup = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "column_multiaxislist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + "" + "\"}";
                                var Widget4 = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + "" + "\"}";
                                var Widget5 = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + this.state.WidgetList[0].widgetAPI + "\"}";
                                var Widget6 = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"widget_link\"" + ":\"" + this.state.WidgetList[0].widgetAPI + "\"}";
                                var primaryColor;
                                var secondaryColor;

                                if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
                                    primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
                                    secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
                                } else {
                                    primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
                                    secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
                                }

                                if (this.state.isEnrollEndpointEnabled == true) {
                                    this.setState({
                                        dashboardName: wname,
                                        graphData: [
                                            {
                                                url: APIBaseURL + "/date_wise_signup",
                                                type: this.state.WidgetList[0].widgetType,
                                                title: this.state.WidgetList[0].widgetTitle,
                                                Subtitle: this.state.WidgetList[0].widgetSubTitle,
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Date",
                                                YlabelString: "Number of Signups",
                                                interval: 'day',
                                                id: "Alalytic_widget1",
                                                RequestJson: Widget1,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/gn_wise_signup",
                                                type: this.state.WidgetList[1].widgetType,
                                                title: this.state.WidgetList[1].widgetTitle,
                                                Subtitle: this.state.WidgetList[1].widgetSubTitle,
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Group Number",
                                                YlabelString: "Number of Signups",
                                                id: "Alalytic_widget2",
                                                RequestJson: Widget2,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/devicedatesignup",
                                                type: "MultiBar_List",
                                                title: "Client Access Link Signups",
                                                Subtitle: "Number of signups through Client Access Links",
                                                ColorCode: primaryColor,
                                                DataType: "NA",
                                                XlabelString: "Date",
                                                YlabelString: "Number of Signups",
                                                //interval: 'date',
                                                id: "Alalytic_widget3",
                                                RequestJson: MultiAxis_DeviceSignup,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/devicegnsignup",
                                                type: "Bar_List",
                                                title: "Client Access Link Signups by Group Number",
                                                Subtitle: "Number of signups through Client Access Links for each group number",
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Group Number",
                                                YlabelString: "Number of Signups",
                                                //interval: 'date',
                                                id: "Alalytic_widget4",
                                                RequestJson: Widget4,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/date_wise_signup_api",
                                                type: "Bar_List",
                                                title: "API Signups",
                                                Subtitle: "Number of signups through API",
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Date",
                                                YlabelString: "Number of Signups",
                                                interval: 'day',
                                                id: "Alalytic_widget5",
                                                RequestJson: Widget5,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/gn_wise_signup_api",
                                                type: "Bar_List",
                                                title: "API Signups by Group Number",
                                                Subtitle: "Number of signups through API for each group number",
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Group Number",
                                                YlabelString: "Number of Signups",
                                                id: "Alalytic_widget6",
                                                RequestJson: Widget6,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            }
                                        ]
                                    });

                                }
                                else {
                                    this.setState({
                                        dashboardName: wname,
                                        graphData: [
                                            {
                                                url: APIBaseURL + "/date_wise_signup",
                                                type: this.state.WidgetList[0].widgetType,
                                                title: this.state.WidgetList[0].widgetTitle,
                                                Subtitle: this.state.WidgetList[0].widgetSubTitle,
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Date",
                                                YlabelString: "Number of Signups",
                                                interval: 'day',
                                                id: "Alalytic_widget1",
                                                RequestJson: Widget1,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/gn_wise_signup",
                                                type: this.state.WidgetList[1].widgetType,
                                                title: this.state.WidgetList[1].widgetTitle,
                                                Subtitle: this.state.WidgetList[1].widgetSubTitle,
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Group Number",
                                                YlabelString: "Number of Signups",
                                                id: "Alalytic_widget2",
                                                RequestJson: Widget2,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/devicedatesignup",
                                                type: "MultiBar_List",
                                                title: "Client Access Link Signups",
                                                Subtitle: "Number of signups through Client Access Links",
                                                ColorCode: primaryColor,
                                                DataType: "NA",
                                                XlabelString: "Date",
                                                YlabelString: "Number of Signups",
                                                //interval: 'date',
                                                id: "Alalytic_widget3",
                                                RequestJson: MultiAxis_DeviceSignup,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            },
                                            {
                                                url: APIBaseURL + "/devicegnsignup",
                                                type: "Bar_List",
                                                title: "Client Access Link Signups by Group Number",
                                                Subtitle: "Number of signups through Client Access Links for each group number",
                                                ColorCode: secondaryColor,
                                                DataType: "NA",
                                                XlabelString: "Group Number",
                                                YlabelString: "Number of Signups",
                                                //interval: 'date',
                                                id: "Alalytic_widget4",
                                                RequestJson: Widget4,
                                                RequestJson1: JSON.stringify(AdFilterJson)
                                            }
                                        ]
                                    });
                                }
                                let temp_graphdata = this.state.graphData;
                                if (this.state.Enrollment_Center_Signup == false) {
                                    temp_graphdata = temp_graphdata.filter((item) => { return (item.id != "Alalytic_widget1" && item.id != "Alalytic_widget2") })
                                }
                                if (this.state.Client_Acces_Link_Signup == false) {
                                    temp_graphdata = temp_graphdata.filter((item) => { return (item.id != "Alalytic_widget3" && item.id != "Alalytic_widget4") })
                                }
                                if (this.state.API_Signup == false) {
                                    temp_graphdata = temp_graphdata.filter((item) => { return (item.id != "Alalytic_widget5" && item.id != "Alalytic_widget6") })
                                }
                                this.setState({ graphData: temp_graphdata })
                            }
                        }
                        catch (error) { }
                    }
                }
            );
        }
        catch (error) { }

    }
    HandleSearchKeyUp = e => {
        if ($('#myInput').val().length >= 2) {
            let whid = this.state.userdata.wholesaler_Id;
            this.GetSearchDataList($('#myInput').val(), whid);
        }
        else {
            this.setState({ SearchDispay: null });
        }
    }
    HandleSearchFocus = e => {
        if ($('#myInput').val().length == 0) {
            this.setState({ SearchDispay: null });
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    GetSearchDataList(text, val) {
        $('#myInputautocomplete-list').css('display', 'block');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text, val })
        };
        return fetch(`/api/Filter/SearchOnTypeText_GetBrokerData`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ SearchDispay: apidata });
                }
                catch (error) {
                    this.setState({ SearchDispay: null });
                }
            });
    }
    RepeatCode = (e) => {
        try {
            var startdate = new Date();
            startdate.setDate(startdate.getDate() - 30);
            var enddate = new Date();
            if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
                startdate = localStorage.getItem('User_Start_Date');
            }
            if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
                enddate = localStorage.getItem('User_End_Date');
            }
            startdate = new moment(startdate).format("MM/DD/YYYY");
            enddate = new moment(enddate).format("MM/DD/YYYY");
            localStorage.setItem('Filter_Last_Update_Time', new Date());
            this.changeData(true, startdate, enddate, '-1');
        }
        catch (error) { }
    }
    HandleSearchItemClick = e => {
        $('#myInput').val('');
        $('#myInputautocomplete-list').css('display', 'none');
        this.setState({ SearchDispay: [] });
        var nodevalue = $(e.target).attr('nodename');
        var nodetype = $(e.target).attr('nodetype');
        try {
            this.Create_Advance_FIlter_Json(nodetype, nodevalue);
        }
        catch (error) { }
        try {
            var startdate = new Date();
            startdate.setDate(startdate.getDate() - 30);
            var enddate = new Date();
            if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
                startdate = localStorage.getItem('User_Start_Date');
            }
            if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
                enddate = localStorage.getItem('User_End_Date');
            }
            startdate = new moment(startdate).format("MM/DD/YYYY");
            enddate = new moment(enddate).format("MM/DD/YYYY");
            let newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate);
            this.changeData(true, startdate, enddate, $(e.target).attr('nodevalue'));
            var AnalyticFilterJson = '';
            try {
                AnalyticFilterJson = JSON.parse(localStorage.getItem('Analytic_Filter'))
                if (AnalyticFilterJson != null && AnalyticFilterJson != '' && AnalyticFilterJson != undefined && AnalyticFilterJson != "null") {
                    this.setState({ FilterTagList: JSON.stringify(AnalyticFilterJson) });
                }
                else {
                    this.setState({ FilterTagList: '' });
                }
            }
            catch (error) {
                this.setState({ FilterTagList: '' });
            }

            let ds = new moment(startdate).format("YYYYMMDD");
            let de = new moment(enddate).format("YYYYMMDD");
            let nJson = JSON.stringify(AnalyticFilterJson);
            if (AnalyticFilterJson != null) {
                this.BindFilteredTag(this.state.userdata["userrole"], -1, this.state.userdata["wholesaler"], this.state.userdata["wholesaler_Id"], ds, de, nJson);
            }

        }
        catch (error) { }
    }
    Create_Advance_FIlter_Json(nodetype, nodevalue) {
        var Created_Advance_Filter = JSON.parse(localStorage.getItem('Analytic_Filter'));
        var arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter != '' && Created_Advance_Filter != undefined && Created_Advance_Filter != "null" && Created_Advance_Filter != "{}") {
            var IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }))
            for (var ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name == nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].map((e1, i1) => {
                        if (e1.toLowerCase() == nodevalue.toLowerCase()) {
                            checkavail = checkavail + 1;
                        }
                    });
                    if (checkavail == 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Analytic_Filter', JSON.stringify(Created_Advance_Filter));
                        let newDate = new Date();
                        localStorage.setItem('An_Filter_Last_Update_Time', newDate);
                        localStorage.setItem('An_Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                        // this.handlechangea();

                    }
                    break;
                }
                else {
                    continue;
                }
            }
            if (IsMatched == false) {
                try {
                    var JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Analytic_Filter', TempJson);
                    let newDate = new Date();

                    localStorage.setItem('An_Filter_Last_Update_Time', newDate);
                    localStorage.setItem('An_Updated_AdFilter_Status', TempJson);
                    //this.handlechangea();

                }
                catch (error) {
                }
            }

        }
        else {

            var JsonData = '';
            try {
                JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                localStorage.setItem('Analytic_Filter', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                let newDate = new Date();
                localStorage.setItem('An_Filter_Last_Update_Time', newDate);
                localStorage.setItem('An_Updated_AdFilter_Status', JSON.stringify(Created_Advance_Filter));
                this.handlechangea();

            }
            catch (error) {

            }
        }
    }
    GetTagTypeFullName(stext) {
        if (stext == 'PBM') {
            return 'PCN';
        }
        else if (stext == 'DistributorName') {
            return 'Broker Name'
        }
        else if (stext == 'PhCity') {
            return 'Pharmacy City'
        }
        else if (stext == 'PrCity') {
            return 'Prescriber City'
        }
        else if (stext == 'PhState') {
            return 'Pharmacy State'
        }
        else if (stext == 'PrState') {
            return 'Prescriber State'
        }
        else if (stext == 'PhZip') {
            return 'Pharmacy ZIP'
        }
        else if (stext == 'PrZip') {
            return 'Prescriber ZIP'
        }
        else if (stext == 'PharmacyName') {
            return 'Pharmacy Name'
        }
        else if (stext == 'GroupNumber') {
            return 'Group Number'
        }
        else if (stext == 'WholesalerName') {
            return 'Wholesaler Name'
        }
        //else if (stext == 'Wholesaler_Id') {
        //    return 'Wholesaler ID'
        //}
        else if (stext == 'DrugName') {
            return 'Drug Name'
        }
        else if (stext == 'Prescriber') {
            return 'Prescriber Name'
        }

    }
    HandleRemoveTag = e => {
        try {
            let dnodename = $(e.target).parent().attr('nodename');
            let dnodeval = $(e.target).parent().attr('nodevalue');
            try {
                let ExistJson = JSON.parse(localStorage.getItem('Analytic_Filter'));
                let ItemIndex = ExistJson[dnodename].indexOf(dnodeval);
                if (ItemIndex > -1) {
                    ExistJson[dnodename].splice(ItemIndex, 1);
                    if (ExistJson[dnodename].length == 0) {
                        delete ExistJson[dnodename]
                    }
                }
                try {
                    if (JSON.stringify(ExistJson) == "{}") {
                        localStorage.setItem('Analytic_Filter', null);
                    }
                    else {
                        localStorage.setItem('Analytic_Filter', JSON.stringify(ExistJson));
                    }
                    var AnalyticFilterJson = '';
                    try {
                        AnalyticFilterJson = JSON.parse(localStorage.getItem('Analytic_Filter'))
                        if (AnalyticFilterJson != null && AnalyticFilterJson != '' && AnalyticFilterJson != undefined && AnalyticFilterJson != "null") {
                            this.setState({ FilterTagList: JSON.stringify(AnalyticFilterJson) });
                        }
                        else {
                            this.setState({ FilterTagList: '' });
                        }
                    }
                    catch (error) {
                        this.setState({ FilterTagList: '' });
                    }
                    let ds = new moment(this.state.startDate).format("YYYYMMDD");
                    let de = new moment(this.state.endDate).format("YYYYMMDD");
                    let nJson = JSON.stringify(AnalyticFilterJson);
                    if (AnalyticFilterJson != null) {
                        this.BindFilteredTag(this.state.userdata["userrole"], -1, this.state.userdata["wholesaler"], this.state.userdata["wholesaler_Id"], ds, de, nJson);
                    }
                }
                catch (error) {
                }
                this.RepeatCode();
            }
            catch (error) {
            }
        } catch (error) {
        }
    }
    HandleResetButton = e => {
        try {
            $("span." + "filtered_tag_dashboard").hide();
            $('button[class="reset-btn"]').css('display', 'none');
            this.setState({ loading: false });
            localStorage.setItem('Analytic_Filter', null);
            this.RepeatCode();
        }
        catch (error) {
        }
    }
    BindFilteredTag(role, distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson) {
        try {
            userService.BindAnalyticsFilteredTag(role, distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson).then(
                apidata => {
                    try {
                        this.setState({ ...this.state, FilterTagList: JSON.parse(FilterJson), FilterMatchedTagList: apidata });
                    }
                    catch (error) {
                        try {
                            this.setState({ FilterTagList: JSON.parse(FilterJson), FilterMatchedTagList: apidata });
                        }
                        catch (error) {
                        }
                    }
                }
            );
        }
        catch (error) {
        }
    }
    GetWholesalers_Enrollment_API_Status(Wh_Id) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Wh_Id })
            };
            return fetch(`/api/Analytic/getWholesalers_Enrollment_API_Status`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ isEnrollEndpointEnabled: apidata[0].colValue, API_Signup: apidata[1].colValue, Enrollment_Center_Signup: apidata[2].colValue, Client_Acces_Link_Signup: apidata[3].colValue });
                        }
                        this.changeData();
                    }
                    catch (error) {
                        this.setState({ loading: false, error: 'Error. Please try later.', IsResetDone: true });
                        this.changeData();
                        return false;
                    }
                });
        }
        catch (error) {
            this.setState({ loading: false, error: 'Error. Whoops, something went wrong. Please try again.', IsResetDone: true });
            this.changeData();
            return false;
        }
    }
    render() {
        let LocalAnayticFilterJson = '';
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        LocalAnayticFilterJson = JSON.parse(localStorage.getItem('Analytic_Filter'));
        return (
            <div className="anylytics wholesale">
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="dashboard-content-parent">
                    <div className="newBoard">
                        <div className="parent">
                            <div className="contentContainer">
                                <div>
                                    <div className='row'>
                                        <div className='double-column'>
                                            <div className="dashboard-container analytics" id="dashboard-container">
                                                <h2 className="dashboardHeading">Signups<span className="beta-link"><span className="beta">Beta</span></span></h2>

                                                <div id="dashboard_header_inner" className="admin-login">
                                                    <div id="dashboard_header_select">
                                                        <DateRangePicker 
                                                            popperModifiers={{ preventOverflow: { enabled: true, }, }} 
                                                            initialSettings={{
                                                                startDate: this.state.startDate,
                                                                endDate: this.state.endDate,
                                                                maxDate: moment().toDate(),
                                                                locale: {
                                                                    format: 'MM/DD/YYYY'
                                                                }
                                                            }}
                                                            onApply={this.handleCalendar}
                                                        >
                                                            <div className="react-bootstrap-daterangepicker-container">
                                                                <div className="react-datepicker_input-container first-one">
                                                                    <input type="text" className="form-control first readonly-attr" value={this.state.startDate} />
                                                                </div>
                                                                <div className="react-datepicker_input-container second-one">
                                                                    <input type="text" className="form-control readonly-attr" value={this.state.endDate} />
                                                                </div>
                                                            </div>
                                                        </DateRangePicker>
                                                        <div className='searchSection'>
                                                            <img className="SearchIcon" src={Search_Icon} alt="" />

                                                            <form autoComplete="off">
                                                                <div className="autocomplete">
                                                                    <input id="myInput" type="text" name="myCountry" placeholder="Search" className="form-control searchFilter" onFocus={this.HandleSearchFocus} onKeyUp={this.HandleSearchKeyUp} />
                                                                    {
                                                                        this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                                                            <div id="myInputautocomplete-list" className="autocomplete-items">
                                                                                {
                                                                                    this.state.SearchDispay.map((item, index) => {
                                                                                        return (<div className="searchitempopulate" nodename={item.value} nodevalue={item.iD} nodetype={item.cType} onClick={this.HandleSearchItemClick}>{item.value}
                                                                                            <span nodename={item.value} nodevalue={item.iD} nodetype={item.cType}></span>
                                                                                        </div>
                                                                                        )
                                                                                    })}
                                                                            </div> : null : null
                                                                    }
                                                                </div>
                                                            </form>

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clear"></div>

                                                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                                                {
                                                    //LocalAnayticFilterJson != null && LocalAnayticFilterJson.propertyIsEnumerable.length > 0 ?
                                                    <div className='filtered_tag_selected anlytical-tag'>
                                                        {
                                                            this.state.FilterTagList != null ?
                                                                <div className="filtered_content">
                                                                    <div className="filtered_adjust">
                                                                        {
                                                                            Object.keys(this.state.FilterTagList).map((key, index) => {
                                                                                try {
                                                                                    let act = '';
                                                                                    if (this.state.FilterMatchedTagList.filter((d) => d["tableType"] == key).length > 0) {
                                                                                        let KeyValue = this.state.FilterMatchedTagList.filter(function (m1) {
                                                                                            return m1.tableType == key
                                                                                        });
                                                                                        try {
                                                                                            return (
                                                                                                KeyValue.map((k1, ik) => {
                                                                                                    try {
                                                                                                        if (k1.hasData == "True") {
                                                                                                            act = 'filtered_tag_dashboard active'
                                                                                                        }
                                                                                                        else {
                                                                                                            act = 'filtered_tag_dashboard';
                                                                                                        }
                                                                                                        return (
                                                                                                            <span id={key.replace(' ', '') + k1.value.replace(' ', '')} className={act} nodename={key} nodevalue={k1.value}>{this.GetTagTypeFullName(key) + '-' + k1.value}<label onClick={this.HandleRemoveTag}></label></span>
                                                                                                        )
                                                                                                    } catch (error) {
                                                                                                    }
                                                                                                })
                                                                                            )
                                                                                        }
                                                                                        catch (error) {
                                                                                        }
                                                                                    }
                                                                                    else {
                                                                                        this.state.FilterTagList[key].map((e1, i1) => {

                                                                                            return (
                                                                                                <span id={key.replace(' ', '') + e1.replace(' ', '')} className='filtered_tag_dashboard' nodename={key} nodevalue={e1}>{this.GetTagTypeFullName(e1) + '-' + e1}<label onClick={this.HandleRemoveTag}></label></span>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                }
                                                                                catch (error) {
                                                                                }
                                                                            })
                                                                        }
                                                                    </div>
                                                                    {
                                                                        LocalAnayticFilterJson != null ?
                                                                            <button className="reset-btn" onClick={this.HandleResetButton}>Reset</button> : null
                                                                    }
                                                                </div>
                                                                : null
                                                        }
                                                    </div>
                                                    //:
                                                    //<div className='filtered_tag_selected anlytical-tag'>
                                                    //    {
                                                    //        <div className="filtered_content">
                                                    //            <div className="filtered_adjust">
                                                    //            </div>
                                                    //        </div>
                                                    //    }
                                                    //</div>

                                                }
                                                {
                                                    this.state.graphData.map((item, index, id) => {
                                                        var k = null;
                                                        return (
                                                            //(this.state.userdata["wholesaler_Id"] != 144 && (index == 5 || index == 4)) ? null :
                                                            <div id={item.id + index} className={`${item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third"}${item.id == "Alalytic_widget1" ? ' layout-not-margin barlist' : ''}${item.id == "Alalytic_widget2" ? ' layout-left-margin barlist' : ''}${item.id == "Alalytic_widget3" ? ' layout-not-margin barlist' : ''}${item.title == "Client Access Link Signups by Group Number" ? ' layout-left-margin barlist' : ''}${item.id == "Alalytic_widget5" ? ' barlist' : ''}${item.id == "Alalytic_widget6" ? ' barlist' : ''}`} key={"graph-widget" + index}>
                                                                <div className="widget-content" key={"graph-widget-content" + index}>
                                                                    <div className="custom-scroll">
                                                                        {
                                                                            <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                                {item.type == "Bar_List" ? <Bar_List data={item} key={"barlistgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                {item.type == "MultiBar_List" ? <MultiBar_List data={item} key={"barlistgraph1" + index} _Index={index} /> : null}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="widget-foot">
                                                                    &nbsp;
                                                                        </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                <div className="sortby">
                                                    <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Calendar</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Analytics;